import { useQuery } from '@tanstack/react-query';

import { useQueryKeys } from '@/shared/hooks/use-query-keys';
import { FetchCampaignOverview } from '..';

export function useCampaignOverview(campaignId: string) {
  const queryKeys = useQueryKeys();

  return useQuery({
    queryKey: queryKeys.campaign.overview(campaignId),
    queryFn: async ({ signal }) => FetchCampaignOverview(campaignId, signal),
    staleTime: 30_000,
  });
}
